import * as tslib_1 from "tslib";
import { EventEmitter, OnInit, Renderer2 } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { FormComponentBase } from '../../../../common/form-component-base';
import { Global } from '../../../../common/global';
import { SalaryRecordItemHelper } from '../../../../employee/employee-tab/payroll/controls/salary-record-item-helper';
import { UnitTypeEnum } from '../../../../model/enum';
import { DataService } from '../../../../services/api/data.service';
import { StaticDataService } from '../../../../services/api/static-data.service';
import { SessionService } from '../../../../services/session/session.service';
import { CompanyTemplatesService } from '../templates.service';
var SalaryTemplateDialogComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SalaryTemplateDialogComponent, _super);
    function SalaryTemplateDialogComponent(dataService, staticDataService, renderer, sessionService, companyTemplatesService) {
        var _this = _super.call(this) || this;
        _this.dataService = dataService;
        _this.staticDataService = staticDataService;
        _this.renderer = renderer;
        _this.sessionService = sessionService;
        _this.companyTemplatesService = companyTemplatesService;
        _this.salaryTemplateChange = new EventEmitter();
        _this.visibleValue = false;
        _this.visibleChange = new EventEmitter();
        _this.updatedSalaryTemplateChange = new EventEmitter();
        _this.gridData = [];
        _this.numericOptions = { format: 'n2', decimals: 2, step: 1, min: null, spinners: false };
        _this.confirmationDialogVisible = false;
        _this.dirty = false;
        _this.loadSalaryRecords = true;
        _this.customDeleteRow = false;
        _this.refreshData = false;
        _this.keyPress = { 17: false, 18: false, 107: false, 109: false };
        _this.companyTemplatesService.selectedTemplateIdChange
            .pipe(takeUntil(_this.ngUnsubscribe))
            .subscribe(function (value) {
            if (value) {
                _this.templateId = value;
                _this.loadSalaryTemplateRecords();
            }
        });
        return _this;
    }
    Object.defineProperty(SalaryTemplateDialogComponent.prototype, "IncomeTypeId", {
        get: function () {
            return this.incomeTypeId;
        },
        set: function (value) {
            this.incomeTypeId = value;
            this.filterSalaryType();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalaryTemplateDialogComponent.prototype, "visible", {
        get: function () {
            return this.visibleValue;
        },
        set: function (value) {
            var _this = this;
            if (this.visibleValue !== value) {
                if (value) {
                    document.getElementById('salaryTemplateDialog').addEventListener('keydown', function (event) {
                        _this.onKeyDown(event);
                    });
                }
                this.visibleValue = value;
                this.visibleChange.emit(value);
                if (value && (!this.isDirty || this.loadSalaryRecords)) {
                    this.loadSalaryTemplateRecords();
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalaryTemplateDialogComponent.prototype, "templateId", {
        get: function () {
            return this.templateIdValue;
        },
        set: function (value) {
            if (this.templateIdValue !== value) {
                this.templateIdValue = value;
                this.loadSalaryRecords = true;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalaryTemplateDialogComponent.prototype, "updatedSalaryTemplate", {
        get: function () {
            return this.updatedSalaryTemplateValue;
        },
        set: function (value) {
            this.updatedSalaryTemplateValue = value;
            this.updatedSalaryTemplateChange.emit(value);
        },
        enumerable: true,
        configurable: true
    });
    SalaryTemplateDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadSalaryTypes();
        this.unitTypes = Global.UNIT_TYPES;
        // document.getElementById("salaryTemplateDialog").addEventListener("keydown", (event: any): void => {
        //     this.onKeyDown(event);
        // });
        this.staticDataService.SalaryRecordPersistenceType.pipe(takeUntil(this.ngUnsubscribe)).subscribe(function (data) { return (_this.persistanceTypes = data); });
    };
    SalaryTemplateDialogComponent.prototype.hasChanges = function () {
        return this.dirty;
    };
    SalaryTemplateDialogComponent.prototype.loadSalaryTypes = function () {
        var _this = this;
        this.dataService.SalaryTypes_GetSalaryTypeViews().subscribe(function (salaryTypes) {
            if (salaryTypes && salaryTypes.length > 0) {
                _this.baseSalaryTypes = salaryTypes.filter(function (salaryType) { return salaryType.IsVisible; });
                _this.filterSalaryType();
            }
        });
    };
    SalaryTemplateDialogComponent.prototype.filterSalaryType = function () {
        if (this.baseSalaryTypes && this.baseSalaryTypes.length > 0) {
            if (this.IncomeTypeId && this.IncomeTypeId === 5) {
                this.salaryTypes = this.baseSalaryTypes.filter(function (salaryType) { return salaryType.RelatesToIncomeType5 !== false; });
            }
            else {
                this.salaryTypes = this.baseSalaryTypes.filter(function (salaryType) { return !salaryType.RelatesToIncomeType5; });
            }
        }
    };
    SalaryTemplateDialogComponent.prototype.loadSalaryTemplateRecords = function () {
        var _this = this;
        this.selectedRecord = undefined;
        this.loadSalaryRecords = false;
        this.dataService
            .EmploymentTemplates_GetTemplateSalaryRecordByEmploymentTemplate(this.templateId)
            .subscribe(function (salaryRecords) {
            _this.gridData = salaryRecords.map(function (data) {
                var view = data;
                view.GridId = view.Id;
                _this.updateView(view);
                return view;
            });
        });
    };
    SalaryTemplateDialogComponent.prototype.onGridSelectionChange = function (record) {
        this.selectedRecord = record;
    };
    SalaryTemplateDialogComponent.prototype.onGridAdd = function (record) {
        record.GridId = 0 - (this.gridData.length + 1);
        record.Id = null;
        record.Units = null;
        record.AmountPerUnit = null;
        record.Amount = null;
        record.BaseAmount = null;
        record.AllowEditUnitType = true;
        record.AmountPerUnitEnabled = true;
        record.EmploymentTemplateId = this.templateId;
        record.IsActive = true;
        record.SalaryTypeId = this.salaryTypes[0].SalaryTypeId;
        record.PersistenceTypeId = this.persistanceTypes[0].Id;
        this.selectedRecord = record;
        var salaryRecordItemHelper = new SalaryRecordItemHelper(this.selectedRecord, this.renderer, this.persistanceTypes, this.salaryTypes);
        salaryRecordItemHelper.updateRelavantFields({ SalaryTypeId: this.selectedRecord.SalaryTypeId }, false);
        this.updateView(this.selectedRecord);
        this.updatedSalaryTemplate = this.gridData;
        this.setComponentDirty();
    };
    SalaryTemplateDialogComponent.prototype.onGridRemove = function (args) {
        if (this.customDeleteRow) {
            var dataItem = args ? args.dataItem : args;
            if (dataItem && dataItem.Id) {
                this.gridRemoveRowArgs = args;
                this.confirmationDialogVisible = true;
            }
            else if (dataItem) {
                var dataIndex = this.gridData.indexOf(dataItem);
                this.gridData.splice(dataIndex, 1);
                this.updatedSalaryTemplate = this.gridData;
                this.setComponentDirty();
            }
        }
        else {
            this.updatedSalaryTemplate = this.gridData;
            this.setComponentDirty();
        }
    };
    SalaryTemplateDialogComponent.prototype.onConfirmationDialogAction = function (action) {
        if (action === 'Delete' && this.gridRemoveRowArgs) {
            var indexOfRemovedItem = this.gridData.indexOf(this.gridRemoveRowArgs.dataItem);
            this.gridData.splice(indexOfRemovedItem, 1);
            this.gridRemoveRowArgs.sender.closeRow(this.gridRemoveRowArgs.rowIndex);
            this.updatedSalaryTemplate = this.gridData;
            this.setComponentDirty();
        }
        this.gridRemoveRowArgs = undefined;
    };
    SalaryTemplateDialogComponent.prototype.onGridSave = function (args) {
        var dataItem = args.dataItem, column = args.column, formGroup = args.formGroup;
        this.selectedRecord = dataItem ? dataItem : args;
        var modifiedField = {};
        if (column) {
            modifiedField[column.field] = dataItem[column.field];
        }
        var salaryRecordItemHelper = new SalaryRecordItemHelper(this.selectedRecord, this.renderer, this.persistanceTypes, this.salaryTypes);
        var valid = salaryRecordItemHelper.validate(modifiedField);
        if (!valid) {
            if (column && column.field && formGroup && formGroup.value) {
                // Revert invalid values.
                dataItem[column.field] = formGroup.value[column.field];
            }
            return;
        }
        salaryRecordItemHelper.updateRelavantFields(modifiedField, false);
        this.updateView(this.selectedRecord);
        this.updatedSalaryTemplate = this.gridData;
        this.setComponentDirty();
    };
    SalaryTemplateDialogComponent.prototype.updateView = function (view) {
        var salaryType = this.getSalaryType(view.SalaryTypeId);
        if (salaryType) {
            view.AllowEditUnitType = salaryType.AllowEditUnitType;
            view.UnitTypeClass = view.AllowEditUnitType ? '' : 'grid-disable-cell';
        }
        view.UnitsEnabled = !!view.UnitTypeId;
        view.UnitsClass = view.UnitsEnabled ? '' : 'grid-disable-cell';
        view.AmountPerUnitEnabled = !!view.UnitTypeId && view.UnitTypeId !== UnitTypeEnum.Percent;
        view.AmountPerUnitClass = view.AmountPerUnitEnabled ? '' : 'grid-disable-cell';
    };
    SalaryTemplateDialogComponent.prototype.getSalaryType = function (salaryTypeId) {
        if (!salaryTypeId || !this.salaryTypes || this.salaryTypes.length === 0) {
            return undefined;
        }
        return this.salaryTypes.find(function (e) { return e.SalaryTypeId === salaryTypeId; });
    };
    SalaryTemplateDialogComponent.prototype.setComponentDirty = function () {
        this.dirty = true;
        this.onChange();
        this.salaryTemplateChange.emit();
    };
    SalaryTemplateDialogComponent.prototype.onKeyDown = function (event) {
        if (this.visible) {
            if (this.editMode) {
                if (event.keyCode in this.keyPress) {
                    this.keyPress[event.keyCode] = true;
                    if (this.keyPress[17] && this.keyPress[18] && this.keyPress[109]) {
                        if (this.selectedRecord) {
                            this.onGridRemove(this.selectedRecord);
                            this.setKeypress();
                            this.refreshData = true;
                            this.selectedRecord = undefined;
                        }
                    }
                }
                else {
                    this.setKeypress();
                }
            }
        }
    };
    SalaryTemplateDialogComponent.prototype.setKeypress = function () {
        this.keyPress[17] = false;
        this.keyPress[18] = false;
        this.keyPress[107] = false;
        this.keyPress[109] = false;
    };
    return SalaryTemplateDialogComponent;
}(FormComponentBase));
export { SalaryTemplateDialogComponent };
